import React, { useMemo } from "react";
import { BASE_BUTTON_CLASS, POPUP_TYPE } from "../constants/common";
import { classnames } from "../utils/general";

const Popup = ({ screen, openPopup, setOpenPopup, handleSubmit, message = '' }) => {

  const overlayModalClass = classnames(
    "fixed bottom-0 left-0 flex flex-col items-center justify-center z-[50]",
    "h-[170px] px-[18px] pt-2 rounded-t-[20px] w-[100%] bg-white",
    "text-center tracking-[-0.15px] text-base sm:text-lg font-normal",
    "sm:relative sm:w-[320px] sm:h-fit sm:rounded-[20px]",
    `${screen === POPUP_TYPE.START_SESSION ? 'sm:w-[500px] sm:pt-10 sm:pb-6' : 'sm:py-8'} `
  );
  
  return (
    <>
      {
        openPopup &&
        <div
          className={classnames(`fixed left-0 top-0 w-full h-full 
              sm:flex sm:items-center sm:justify-center z-[40] backdrop-blur`
          )}
        >
          <div className="fixed left-0 top-0 min-w-full min-h-full bg-[rgba(39,39,39,0.9)] z-[40]"></div>
          <div className={overlayModalClass}>
            <div className="relative bottom-4 text-lg tracking-[-0.8px] text-center font-medium w-[100%] flex flex-wrap items-center justify-center">
              <h3>
                {
                  screen === POPUP_TYPE.SUBMIT ?
                  `${message} Are you sure you want to submit the code ?`:
                  message
                  // 'Please note that the coding test will be auto-submitted in 10 minutes from now (12.20 PM) even if you close the window, so please be cognizant of time while attempting. Lets start?'
                }
              </h3>
            </div>
            <div className={`flex ${screen === POPUP_TYPE.START_SESSION ? 'w-[70%]': 'w-[90%]'} mx-auto items-center justify-between`}>
              <button
                className={classnames(
                  BASE_BUTTON_CLASS,
                  "mr-0"
                )}
                onClick={handleSubmit}
              >
                Yes
              </button>
              <button
                className={classnames(
                  BASE_BUTTON_CLASS,
                  "mr-0"
                )}
                onClick={() => setOpenPopup(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default Popup;